import script from "./gestureController.vue?vue&type=script&setup=true&lang=js"
export * from "./gestureController.vue?vue&type=script&setup=true&lang=js"

import "./gestureController.vue?vue&type=style&index=0&id=198b951f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198b951f"]])

export default __exports__